import * as React from 'react';
import { Head } from '@inertiajs/react';

interface SEOBlockProps {
  appUrl: string;
}

export function SEOBlock({ appUrl }: SEOBlockProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Abasto Virtual',
    description: 'Proveedor de frutas y verduras frescas para comedores comunitarios, hogares, fundaciones y organizaciones sociales en Córdoba. Entrega programada, facturación formal y precios mayoristas.',
    url: `${appUrl}/organizaciones-sociales`,
    telephone: '+5493512026384',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Córdoba',
      addressRegion: 'Córdoba',
      addressCountry: 'AR',
    },
    areaServed: {
      '@type': 'City',
      name: 'Córdoba',
    },
    priceRange: '$$',
  };

  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Head>
      <section className="ong-seo">
        <style>{`
          .ong-seo {
            padding: 48px 24px;
            background: #fafaf7;
            border-top: 1px solid #eee;
          }
          .ong-seo-inner {
            max-width: 720px;
            margin: 0 auto;
          }
          .ong-seo h2 {
            font-size: 20px;
            font-weight: 700;
            color: #666;
            margin: 0 0 12px;
          }
          .ong-seo p {
            font-size: 15px;
            color: #888;
            line-height: 1.7;
            margin: 0;
          }
        `}</style>
        <div className="ong-seo-inner">
          <h2>Proveedor de frutas y verduras para organizaciones sociales en Córdoba</h2>
          <p>
            Abasto Virtual provee frutas y verduras frescas a comedores comunitarios, hogares de niños,
            fundaciones y organizaciones sociales en Córdoba. Entrega programada, facturación formal,
            precios mayoristas y calidad constante para comedores solidarios.
          </p>
        </div>
      </section>
    </>
  );
}
